/*
  Object to get performs all the requiests from the server
  Holds and caches the current skill
*/

import $ from 'jquery'
import Module from '../utils/module.js'

// base host for queries
const HOST = '/builder'
// const HOST = 'http://skills.iviet.com:8000/builder'
// const HOST = 'http://localhost:80/builder'

const EMPTY = {
  contexts: [],
  intents: [],
  entities: [],
  synonyms: [],
  public: [],
  scripts: [],
  apis: [],
}

const State = {
  state: { // the state to be used by the components
    loading: false, // if is currently loading the data
    // skill: null, // the skillid currently used (if any)
    error: null,
    user: null,
    token: null,
    settings: {
      empty: true,
      special_skills: {},
      domains: [],
      tone_dimensions: [],
    },
  },
  headers: {}, // the headers to pass to request (mostly the token)
  loading: {}, // mostly stores the promise of the request
  skills: {},
  // what an empty skill should look like
  empty: { data: EMPTY },

  loadPromise (path, promise) {
    this.state.loading = true
    this.loading[path] = promise
    return promise.finally(() => {
      delete this.loading[path]
      setTimeout(() => {
        for (let p in this.loading) return
        this.state.loading = false
      }, 10)
    })
  },

  loadSettings () {
    if (!this.state.settings.empty) {
      return Promise.resolve(this.state.settings)
    }
    return this.reloadSettings()
  },
  reloadSettings () {
    return this.callAPI('/settings').then(data => {
      this.state.settings = data
      return data
    })
  },
  // get the skill and all the interesting stuffs about it
  // it's an heavy request used by mostly any page
  // so it's cached in localStorage
  // however localStorage has no TTL and survive sessions,
  // so a cookie is used to store it's age
  // sessionStorage doesn't spread among tabs :(
  getSkill (skill, view, refresh) {
    /* Get the skill and all the interesting stuffs about it
    It's an heavy request used by mostly any page
      so it's cached in localStorage
      however localStorage has no TTL and survive sessions,
      so a cookie is used to store it's age
      because sessionStorage doesn't spread among tabs :(
    If refresh is true, forces to make the request */
    let path = '/skills/' + skill
    if (view === 'pub') path += '/publish'
    if (view === 'prod') path += '/approve'
    // already loading the data
    if (path in this.loading) {
      return this.loading[path]
    }
    // look in cache
    if (!refresh) {
      // check the age of the localStorage from a cookie
      // also avoids restoring skill after session ended
      let time = document.cookie.match(new RegExp(path + '=(\\d+)'))
      if (time) { // check that is less than 10 minutes
        time = parseInt(time[1])
        if (time && (new Date().getTime() > time + 10 * 3600)) time = null
      }
      // use the skill data in localStorage, if any
      if (time) {
        let json = window.localStorage.getItem(path)
        if (json) {
          let data = JSON.parse(json)
          if (path in this.skills) {
            this.skills[path].json = json
            this.skills[path].data = data
          } else {
            this.skills[path] = {
              path: path,
              json: json,
              data: data,
            }
          }
          if (data.scripts) {
            Module.loadScripts(data.scripts)
          }
          return Promise.resolve(this.skills[path])
        }
      // clean localStorage, who knows
      } else window.localStorage.removeItem(path)
    }
    // request for skill data
    let promise = new Promise((resolve, reject) => {
      $.ajax(HOST + path, {
        headers: { ...this.headers },
        success: (data) => {
          let json = JSON.stringify(data)
          if (path in this.skills) {
            this.skills[path].json = json
            this.skills[path].data = data
          } else {
            this.skills[path] = {
              path: path,
              json: json,
              data: data,
            }
          }
          this.emitSkill(path, json)
          if (data.scripts) {
            Module.loadScripts(data.scripts)
          }
          resolve(this.skills[path])
        },
        error: (error) => {
          console.log('HTTP error', error)
          if (error.status === 401) {
            this.clearSession()
          }
          reject(error)
        },
      })
    })
    return this.loadPromise(path, promise)
  },
  emitSkill (path, json) {
    // save the time in a session cookie
    document.cookie = path + '=' + new Date().getTime()
    // save the skill in localStorage
    window.localStorage.setItem(path, json)
  },
  checkStorage () {
    /* Checks if the version in localStorage has been updated */
    for (let path in this.skills) {
      if (this.loading[path]) continue
      // look for the time cookie
      let time = document.cookie.match(
        new RegExp(path + '=(\\d+)'))
      if (time) {
        time = parseInt(time[1])
        if (time && (new Date().getTime() > time + 10 * 3600)) time = null
      }
      // get the localStorage
      if (time) {
        let json = window.localStorage.getItem(path)
        // data has been updated
        if (json && json !== this.skills[path].json) {
          this.skills[path].json = json
          this.skills[path].data = JSON.parse(json)
        }
      } else window.localStorage.removeItem(path)
    }
  },
  cleanStorage () {
    /* Clens all the skills in localStorage if session cookie is too old */
    for (let skill in window.localStorage) {
      if (skill.substr(0, '/skills/'.length) !== '/skills/') continue
      let time = document.cookie.match(new RegExp(skill + '=(\\d+)'))
      if (time) {
        time = parseInt(time[1])
        if (time && (new Date().getTime() > time + 10 * 3600)) time = null
      }
      if (!time) window.localStorage.removeItem(skill)
    }
  },
  callAPI (url, method, data) {
    /* Performs a generic call to the API */
    let path = Math.random() + ''
    if ((method || 'GET') === 'GET') {
      path = url
      if (path in this.loading) return this.loading[path]
    }
    let promise = new Promise((resolve, reject) => {
      let options = {
        method: method || 'GET',
        headers: { ...this.headers },
        dataType: 'json',
        success: (data) => {
          resolve(data)
        },
        error: (error) => {
          console.log('HTTP error', error)
          this.state.error = error
          if (error.status === 401) {
            this.clearSession()
          }
          reject(error)
        },
      }
      if (data) {
        options.data = JSON.stringify(data)
        options.contentType = 'application/json'
      }
      $.ajax(HOST + url, options)
    })
    return this.loadPromise(path, promise)
  },
  clearSession () {
    this.state.user = null
    this.state.token = null
    delete this.headers['Authorization']
    document.cookie = 'token=;expires=Thu, 01 Jan 1970 00:00:01 GMT'
  },
  checkSession () {
    let token = document.cookie.match(/(?:^|[ ;])token=([^;]+)/)
    if (!token) {
      if (!this.state.token) return
      this.clearSession()
    } else {
      token = token[1]
      if (this.state.token === token) return
      this.state.token = token
      this.headers['Authorization'] = 'Bearer ' + token
      this.getSelf().then(() => this.loadSettings())
    }
  },
  connect (data) {
    delete this.headers['Authorization']
    return this.callAPI('/session', 'POST', data).then(data => {
      this.state.user = data
      let token = data.access_token
      delete data.access_token
      this.state.token = token
      this.headers['Authorization'] = 'Bearer ' + token
      document.cookie = 'token=' + token
      return data
    }).then(() => this.loadSettings())
  },
  disconnect () {
    return this.callAPI('/session', 'DELETE').finally(() => {
      this.clearSession()
    })
  },
  getSelf () {
    return this.callAPI('/session').then(data => {
      this.state.user = data
      return data
    })
  },
  saveSelf (data) {
    return this.callAPI('/users', 'PUT', data)
  },
  listUsers () {
    return this.callAPI('/users')
  },
  getUser (userid) {
    if (userid) return this.callAPI('/users/' + userid)
    else return this.getSelf()
  },
  createUser (data) {
    return this.callAPI('/users', 'POST', data)
  },
  saveUser (userid, data) {
    if (userid) return this.callAPI('/users/' + userid, 'PUT', data)
    else return this.callAPI('/users', 'PUT', data)
  },
  deleteUser (userid) {
    if (userid) return this.callAPI('/users/' + userid, 'DELETE')
    else return this.callAPI('/users', 'DELETE')
  },
  skillFields (data) {
    let basePath = '/skills/' + data.skill
    for (let view of ['', '/publish', '/approve']) {
      let path = basePath + view
      if (!(path in this.skills)) continue
      let skill = this.skills[path]
      for (let field in data) skill.data[field] = data[field]
      skill.json = JSON.stringify(skill.data)
      this.emitSkill(path, skill.json)
    }
    return data
  },
  listSkills (view) {
    if (view === 'pub') view = '/publish'
    else if (view === 'prod') view = '/approve'
    else view = ''
    return this.callAPI('/skills' + view)
  },
  createSkill (data, createid) {
    let suffix = createid ? '/' + createid : ''
    return this.callAPI('/skills' + suffix, 'POST', data)
  },
  saveSkill (skill, data) {
    return this.callAPI('/skills/' + skill, 'PUT', data)
      .then(data => this.skillFields(data))
  },
  removeSkill (skill) {
    return this.callAPI('/skills/' + skill, 'DELETE')
  },
  testSkill (skill) {
    return this.callAPI('/skills/' + skill + '/test', 'POST')
  },
  untestSkill (skill) {
    return this.callAPI('/skills/' + skill + '/test', 'DELETE')
  },
  publishSkill (skill, timestamp) {
    return this.callAPI('/skills/' + skill + '/publish/' + timestamp, 'POST')
      .then(data => this.skillFields(data))
  },
  unpublishSkill (skill, timestamp) {
    return this.callAPI('/skills/' + skill + '/publish/' + timestamp, 'DELETE')
      .then(data => this.skillFields(data))
  },
  restorePublishedSkill (skill, timestamp) {
    return this.callAPI('/skills/' + skill + '/publish/' + timestamp + '/restore', 'POST').then(data => this.skillFields(data))
  },
  rejectSkill (skill, timestamp) {
    return this.callAPI('/skills/' + skill + '/reject/' + timestamp, 'POST')
      .then(data => this.skillFields(data))
  },
  approveSkill (skill, timestamp) {
    return this.callAPI('/skills/' + skill + '/approve/' + timestamp, 'POST')
      .then(data => this.skillFields(data))
  },
  disapproveSkill (skill, timestamp) {
    return this.callAPI('/skills/' + skill + '/approve/' + timestamp, 'DELETE')
      .then(data => this.skillFields(data))
  },
  restoreApprovedSkill (skill, timestamp) {
    return this.callAPI('/skills/' + skill + '/approve/' + timestamp + '/restore', 'POST').then(data => this.skillFields(data))
  },
  createIntent (skill, data, createid) {
    let suffix = createid ? '/' + createid : ''
    return this.callAPI('/skills/' + skill + '/intents' + suffix, 'POST', data)
  },
  intentFields (data) {
    let path = '/skills/' + data.skill
    if (!(path in this.skills)) return data
    let skill = this.skills[path]
    let intent = skill.data.intents.filter(x => x.intent === data.intent)
    if (!intent) return data
    for (let field in data) intent[field] = data[field]
    skill.json = JSON.stringify(skill.data)
    this.emitSkill(path, skill.json)
    return data
  },
  getIntent (skill, intent, view) {
    if (view === 'pub') view = '/publish'
    else if (view === 'prod') view = '/approve'
    else view = ''
    return this.callAPI('/skills/' + skill + '/intents/' + intent + view)
  },
  saveIntent (skill, intent, data) {
    return this.callAPI('/skills/' + skill + '/intents/' + intent, 'PUT', data)
  },
  removeIntent (skill, intent) {
    return this.callAPI('/skills/' + skill + '/intents/' + intent, 'DELETE')
  },
  testIntent (skill, intent) {
    return this.callAPI('/skills/' + skill + '/intents/' + intent + '/test', 'POST')
  },
  untestIntent (skill, intent) {
    return this.callAPI('/skills/' + skill + '/intents/' + intent + '/test', 'DELETE')
  },
  publishIntent (skill, intent, timestamp) {
    return this.callAPI('/skills/' + skill + '/intents/' + intent + '/publish/' + timestamp, 'POST').then(data => this.intentFields(data))
  },
  unpublishIntent (skill, intent, timestamp) {
    return this.callAPI('/skills/' + skill + '/intents/' + intent + '/publish/' + timestamp, 'DELETE').then(data => this.intentFields(data))
  },
  restorePublishedIntent (skill, intent, timestamp) {
    return this.callAPI('/skills/' + skill + '/intents/' + intent + '/publish/' + timestamp + '/restore', 'POST').then(data => this.intentFields(data))
  },
  restoreApprovedIntent (skill, intent, timestamp) {
    return this.callAPI('/skills/' + skill + '/intents/' + intent + '/approve/' + timestamp + '/restore', 'POST').then(data => this.intentFields(data))
  },
  entityFields (data) {
    let path = '/skills/' + (data.skill || 'global')
    if (!(path in this.skills)) return data
    let skill = this.skills[path]
    let entity = skill.data.entities.filter(x => x.entity === data.entity)
    if (!entity) return data
    for (let field in data) entity[field] = data[field]
    skill.json = JSON.stringify(skill.data)
    this.emitSkill(path, skill.json)
    return data
  },
  createEntity (skill, data, createid) {
    let suffix = createid ? '/' + createid : ''
    return this.callAPI('/skills/' + skill + '/entities' + suffix, 'POST', data)
  },
  getEntity (skill, entity, view) {
    if (view === 'pub') view = '/publish'
    else if (view === 'prod') view = '/approve'
    else view = ''
    return this.callAPI('/skills/' + skill + '/entities/' + entity + view)
  },
  saveEntity (skill, entity, data) {
    return this.callAPI('/skills/' + skill + '/entities/' + entity, 'PUT', data)
  },
  removeEntity (skill, entity) {
    return this.callAPI('/skills/' + skill + '/entities/' + entity, 'DELETE')
  },
  testEntity (skill, entity) {
    return this.callAPI('/skills/' + skill + '/entities/' + entity + '/test', 'POST')
  },
  untestEntity (skill, entity) {
    return this.callAPI('/skills/' + skill + '/entities/' + entity + '/test', 'DELETE')
  },
  publishEntity (skill, entity, timestamp) {
    return this.callAPI('/skills/' + skill + '/entities/' + entity + '/publish/' + timestamp, 'POST').then(data => this.entityFields(data))
  },
  unpublishEntity (skill, entity, timestamp) {
    return this.callAPI('/skills/' + skill + '/entities/' + entity + '/publish/' + timestamp, 'DELETE').then(data => this.entityFields(data))
  },
  restorePublishedEntity (skill, entity, timestamp) {
    return this.callAPI('/skills/' + skill + '/entities/' + entity + '/publish/' + timestamp + '/restore', 'POST').then(data => this.entityFields(data))
  },
  rejectEntity (skill, entity, timestamp) {
    return this.callAPI('/skills/' + skill + '/entities/' + entity + '/reject/' + timestamp, 'POST').then(data => this.entityFields(data))
  },
  approveEntity (skill, entity, timestamp) {
    return this.callAPI('/skills/' + skill + '/entities/' + entity + '/approve/' + timestamp, 'POST').then(data => this.entityFields(data))
  },
  disapproveEntity (skill, entity, timestamp) {
    return this.callAPI('/skills/' + skill + '/entities/' + entity + '/approve/' + timestamp, 'DELETE').then(data => this.entityFields(data))
  },
  restoreApprovedEntity (skill, entity, timestamp) {
    return this.callAPI('/skills/' + skill + '/entities/' + entity + '/approve/' + timestamp + '/restore', 'POST').then(data => this.entityFields(data))
  },
  synonymFields (data) {
    let path = '/skills/' + (data.skill || 'global')
    if (!(path in this.skills)) return data
    let skill = this.skills[path]
    let synonym = skill.data.synonyms.filter(x => x.synonym === data.synonym)
    if (!synonym) return data
    for (let field in data) synonym[field] = data[field]
    skill.json = JSON.stringify(skill.data)
    this.emitSkill(path, skill.json)
    return data
  },
  createSynonym (skill, data, createid) {
    let suffix = createid ? '/' + createid : ''
    return this.callAPI('/skills/' + skill + '/synonyms' + suffix, 'POST', data)
  },
  getSynonym (skill, synonym, view) {
    if (view === 'pub') view = '/publish'
    else if (view === 'prod') view = '/approve'
    else view = ''
    return this.callAPI('/skills/' + skill + '/synonyms/' + synonym + view)
  },
  saveSynonym (skill, synonym, data) {
    return this.callAPI('/skills/' + skill + '/synonyms/' + synonym, 'PUT', data)
  },
  removeSynonym (skill, synonym) {
    return this.callAPI('/skills/' + skill + '/synonyms/' + synonym, 'DELETE')
  },
  testSynonym (skill, synonym) {
    return this.callAPI('/skills/' + skill + '/synonyms/' + synonym + '/test', 'POST')
  },
  untestSynonym (skill, synonym) {
    return this.callAPI('/skills/' + skill + '/synonyms/' + synonym + '/test', 'DELETE')
  },
  publishSynonym (skill, synonym, timestamp) {
    return this.callAPI('/skills/' + skill + '/synonyms/' + synonym + '/publish/' + timestamp, 'POST').then(data => this.synonymFields(data))
  },
  unpublishSynonym (skill, synonym, timestamp) {
    return this.callAPI('/skills/' + skill + '/synonyms/' + synonym + '/publish/' + timestamp, 'DELETE').then(data => this.synonymFields(data))
  },
  restorePublishedSynonym (skill, synonym, timestamp) {
    return this.callAPI('/skills/' + skill + '/synonyms/' + synonym + '/publish/' + timestamp + '/restore', 'POST').then(data => this.synonymFields(data))
  },
  rejectSynonym (skill, synonym, timestamp) {
    return this.callAPI('/skills/' + skill + '/synonyms/' + synonym + '/reject/' + timestamp, 'POST').then(data => this.synonymFields(data))
  },
  approveSynonym (skill, synonym, timestamp) {
    return this.callAPI('/skills/' + skill + '/synonyms/' + synonym + '/approve/' + timestamp, 'POST').then(data => this.synonymFields(data))
  },
  disapproveSynonym (skill, synonym, timestamp) {
    return this.callAPI('/skills/' + skill + '/synonyms/' + synonym + '/approve/' + timestamp, 'DELETE').then(data => this.synonymFields(data))
  },
  restoreApprovedSynonym (skill, synonym, timestamp) {
    return this.callAPI('/skills/' + skill + '/synonyms/' + synonym + '/approve/' + timestamp + '/restore', 'POST').then(data => this.synonymFields(data))
  },
  scriptFields (data) {
    let path = '/skills/' + (data.skill || 'global')
    if (!(path in this.skills)) return data
    let skill = this.skills[path]
    let script = skill.data.scripts.filter(x => x.script === data.script)
    if (!script) return data
    for (let field in data) script[field] = data[field]
    skill.json = JSON.stringify(skill.data)
    this.emitSkill(path, skill.json)
    return data
  },
  createScript (skill, data, createid) {
    let suffix = createid ? '/' + createid : ''
    return this.callAPI('/skills/' + skill + '/scripts' + suffix, 'POST', data)
  },
  getScript (skill, script, view) {
    if (view === 'pub') view = '/publish'
    else if (view === 'prod') view = '/approve'
    else view = ''
    return this.callAPI('/skills/' + skill + '/scripts/' + script + view)
  },
  saveScript (skill, script, data) {
    return this.callAPI('/skills/' + skill + '/scripts/' + script, 'PUT', data)
  },
  removeScript (skill, script) {
    return this.callAPI('/skills/' + skill + '/scripts/' + script, 'DELETE')
  },
  testScript (skill, script) {
    return this.callAPI('/skills/' + skill + '/scripts/' + script + '/test', 'POST')
  },
  untestScript (skill, script) {
    return this.callAPI('/skills/' + skill + '/scripts/' + script + '/test', 'DELETE')
  },
  publishScript (skill, script, timestamp) {
    return this.callAPI('/skills/' + skill + '/scripts/' + script + '/publish/' + timestamp, 'POST').then(data => this.scriptFields(data))
  },
  unpublishScript (skill, script, timestamp) {
    return this.callAPI('/skills/' + skill + '/scripts/' + script + '/publish/' + timestamp, 'DELETE').then(data => this.scriptFields(data))
  },
  restorePublishedScript (skill, script, timestamp) {
    return this.callAPI('/skills/' + skill + '/scripts/' + script + '/publish/' + timestamp + '/restore', 'POST').then(data => this.scriptFields(data))
  },
  rejectScript (skill, script, timestamp) {
    return this.callAPI('/skills/' + skill + '/scripts/' + script + '/reject/' + timestamp, 'POST').then(data => this.scriptFields(data))
  },
  approveScript (skill, script, timestamp) {
    return this.callAPI('/skills/' + skill + '/scripts/' + script + '/approve/' + timestamp, 'POST').then(data => this.scriptFields(data))
  },
  disapproveScript (skill, script, timestamp) {
    return this.callAPI('/skills/' + skill + '/scripts/' + script + '/approve/' + timestamp, 'DELETE').then(data => this.scriptFields(data))
  },
  restoreApprovedScript (skill, script, timestamp) {
    return this.callAPI('/skills/' + skill + '/scripts/' + script + '/approve/' + timestamp + '/restore', 'POST').then(data => this.scriptFields(data))
  },
  apiFields (data) {
    let path = '/skills/' + (data.skill || 'global')
    if (!(path in this.skills)) return data
    let skill = this.skills[path]
    let api = skill.data.apis.filter(x => x.api === data.api)
    if (!api) return data
    for (let field in data) api[field] = data[field]
    skill.json = JSON.stringify(skill.data)
    this.emitSkill(path, skill.json)
    return data
  },
  createApi (skill, data, createid) {
    let suffix = createid ? '/' + createid : ''
    return this.callAPI('/skills/' + skill + '/apis' + suffix, 'POST', data)
  },
  getApi (skill, api, view) {
    if (view === 'pub') view = '/publish'
    else if (view === 'prod') view = '/approve'
    else view = ''
    return this.callAPI('/skills/' + skill + '/apis/' + api + view)
  },
  saveApi (skill, api, data) {
    return this.callAPI('/skills/' + skill + '/apis/' + api, 'PUT', data)
  },
  removeApi (skill, api) {
    return this.callAPI('/skills/' + skill + '/apis/' + api, 'DELETE')
  },
  testApi (skill, api) {
    return this.callAPI('/skills/' + skill + '/apis/' + api + '/test', 'POST')
  },
  untestApi (skill, api) {
    return this.callAPI('/skills/' + skill + '/apis/' + api + '/test', 'DELETE')
  },
  publishApi (skill, api, timestamp) {
    return this.callAPI('/skills/' + skill + '/apis/' + api + '/publish/' + timestamp, 'POST').then(data => this.apiFields(data))
  },
  unpublishApi (skill, api, timestamp) {
    return this.callAPI('/skills/' + skill + '/apis/' + api + '/publish/' + timestamp, 'DELETE').then(data => this.apiFields(data))
  },
  restorePublishedApi (skill, api, timestamp) {
    return this.callAPI('/skills/' + skill + '/apis/' + api + '/publish/' + timestamp + '/restore', 'POST').then(data => this.apiFields(data))
  },
  rejectApi (skill, api, timestamp) {
    return this.callAPI('/skills/' + skill + '/apis/' + api + '/reject/' + timestamp, 'POST').then(data => this.apiFields(data))
  },
  approveApi (skill, api, timestamp) {
    return this.callAPI('/skills/' + skill + '/apis/' + api + '/approve/' + timestamp, 'POST').then(data => this.apiFields(data))
  },
  disapproveApi (skill, api, timestamp) {
    return this.callAPI('/skills/' + skill + '/apis/' + api + '/approve/' + timestamp, 'DELETE').then(data => this.apiFields(data))
  },
  restoreApprovedApi (skill, api, timestamp) {
    return this.callAPI('/skills/' + skill + '/apis/' + api + '/approve/' + timestamp + '/restore', 'POST').then(data => this.apiFields(data))
  },
}
export default State

// clean the localStorage when starting
State.cleanStorage()
// keep looking for localStorage update
setInterval(() => State.checkStorage(), 1000)
// check if user is already connected
State.checkSession()
setInterval(() => State.checkSession(), 1000)
